export const EditSpecialisationStaticData = {
  // Breadcrumbs
  myAccountText: 'Profile & Availability',
  editSpecialisationText: 'Edit Specialisation',
  detailsText: 'Details',

  // Subject Card Text
  subjectText: 'Subject',
  levelText: 'Level',
  tagsText: 'Tags',
  newSubjectText: 'New Subject',

  // Default Levels
  beginnersText: 'Beginners',
  intermediateText: 'Intermediate',
  advancedText: 'Advanced',

  // Input Placeholders
  enterSubjectNameText: 'Enter subject name',
  enterLevelText: 'Enter level',
  customTagsPlaceholderText: 'Add custom tags separated by commas (e.g., C++, Java)',

  // Buttons
  addSubjectsText: 'Add Subjects',
  removeSubjectText: 'Remove Subject',
  cancelText: 'Cancel',
  saveChangesText: 'Save Changes',

  // Messages
  loadingText: 'Loading...',
  subjectRequiredText: 'Subject name is required',
  allSubjectsRequiredText: 'All subjects must have a name',
  saveSuccessText: 'Specialisations updated successfully',
  saveErrorText: 'Failed to save specialisations',
  loadErrorText: 'Failed to load specialisations',
};

export const EditSpecialisationHindiData = {
  // Breadcrumbs
  myAccountText: 'प्रोफ़ाइल और उपलब्धता',
  editSpecialisationText: 'विशेषज्ञता संपादित करें',
  detailsText: 'विवरण',

  // Subject Card Text
  subjectText: 'विषय',
  levelText: 'स्तर',
  tagsText: 'टैग',
  newSubjectText: 'नया विषय',

  // Default Levels
  beginnersText: 'नौसिखिया',
  intermediateText: 'मध्यवर्ती',
  advancedText: 'उन्नत',

  // Input Placeholders
  enterSubjectNameText: 'विषय का नाम दर्ज करें',
  enterLevelText: 'स्तर दर्ज करें',
  customTagsPlaceholderText: 'कस्टम टैग अल्पविराम से अलग करके जोड़ें (जैसे, C++, Java)',

  // Buttons
  addSubjectsText: 'विषय जोड़ें',
  removeSubjectText: 'विषय हटाएँ',
  cancelText: 'रद्द करें',
  saveChangesText: 'परिवर्तन सहेजें',

  // Messages
  loadingText: 'लोड हो रहा है...',
  subjectRequiredText: 'विषय का नाम आवश्यक है',
  allSubjectsRequiredText: 'सभी विषयों का नाम होना चाहिए',
  saveSuccessText: 'विशेषज्ञता सफलतापूर्वक अपडेट की गई',
  saveErrorText: 'विशेषज्ञता सहेजने में विफल',
  loadErrorText: 'विशेषज्ञता लोड करने में विफल',
};

export const EditSpecialisationArabicData = {
  // Breadcrumbs
  myAccountText: 'الملف الشخصي والتوفر',
  editSpecialisationText: 'تعديل التخصص',
  detailsText: 'التفاصيل',

  // Subject Card Text
  subjectText: 'المادة',
  levelText: 'المستوى',
  tagsText: 'العلامات',
  newSubjectText: 'مادة جديدة',

  // Default Levels
  beginnersText: 'مبتدئ',
  intermediateText: 'متوسط',
  advancedText: 'متقدم',

  // Input Placeholders
  enterSubjectNameText: 'أدخل اسم المادة',
  enterLevelText: 'أدخل المستوى',
  customTagsPlaceholderText: 'أضف علامات مخصصة مفصولة بفواصل (مثل، C++، Java)',

  // Buttons
  addSubjectsText: 'إضافة المواد',
  removeSubjectText: 'إزالة المادة',
  cancelText: 'إلغاء',
  saveChangesText: 'حفظ التغييرات',

  // Messages
  loadingText: 'جارٍ التحميل...',
  subjectRequiredText: 'اسم المادة مطلوب',
  allSubjectsRequiredText: 'جميع المواد يجب أن تحتوي على اسم',
  saveSuccessText: 'تم تحديث التخصصات بنجاح',
  saveErrorText: 'فشل في حفظ التخصصات',
  loadErrorText: 'فشل في تحميل التخصصات',
};
